"use strict";

import "./Summary.css";
import React from "react";
import Card from "vwa/components/Card";
import Pin from "vwa/components/Pin";

export default class Summary extends React.Component {
	
	constructor(props) {
		super(props);
	}
	
	createTouchProps() {
		
		let pressStarted = false;
		
		return {
			onTouchStart: () => {
				pressStarted = true;
				setTimeout(() => {
					if (pressStarted)
						this.props.onSwitchPOIDetails();
					pressStarted = false;
				}, 1000);
			},
			onTouchEnd: () => {
				pressStarted = false;
			},
			onTouchCancel: () => {
				pressStarted = false;
			}
		};
	}
	
	renderPin() {
		return <Pin
					checked={this.props.pinned}
					onChange={value => this.props.onPinChange(value)}
				/>
	}
	
	renderHeader() {
		return (
			<header>
				<div>
					<div id="nameContainer">
						<h1 onClick={
							evt => {
								evt.stopPropagation();
								this.props.onSwitchPOIDetails();
							}
						}>{this.props.poi.name}</h1>
					</div>
					{this.renderPin()}
				</div>
				<div>
					<label>{this.props.poi.address}</label>
				</div>
			</header>
		);
	}
	
	render() {
		
		const touchProps = this.createTouchProps();
		
		return (
			<Card className="Summary" onClick={_ => this.props.onFocus()} onDoubleClick={ this.props.onSwitchPOIDetails } {...touchProps}>
				{this.renderHeader()}
			</Card>
		);
	}
	
}

Summary.propTypes = {
	poi:				React.PropTypes.object.isRequired,
	pinned:				React.PropTypes.bool,
	onFocus:			React.PropTypes.func,
	onSwitchPOIDetails:		React.PropTypes.func,
	onPinChange:		React.PropTypes.func
};

Summary.defaultProps = {
	onFocus:			() => {},
	onDetailsOpen:		page => {},
	onPinChange:		value => {},
	onSwitchPOIDetails:		() => {}
};


// WEBPACK FOOTER //
// ./src/view/POIList/Summary/Summary.jsx